'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// TODO: refactor this instead of disabling
// eslint-disable-next-line react/display-name
const DriverLogo = /*#__PURE__*/React.forwardRef(({
  s = {}
}, ref) => /*#__PURE__*/React__default["default"].createElement("span", {
  ref: ref
}, /*#__PURE__*/React__default["default"].createElement("svg", {
  viewBox: "0 0 29 28",
  style: {
    width: 29,
    height: 28,
    fill: s.color,
    ...s
  }
}, /*#__PURE__*/React__default["default"].createElement("circle", {
  cx: "14.5",
  cy: "14",
  r: "14",
  fill: s.backgroundColor
}), /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.066 9.54488C10.1297 9.33369 10.3242 9.18916 10.5448 9.18916H18.3251C18.5391 9.18916 18.7294 9.32541 18.7984 9.52804L19.7129 12.2148C19.8233 12.5391 19.5822 12.8759 19.2396 12.8759H9.73502C9.39983 12.8759 9.15957 12.5525 9.25629 12.2316L10.066 9.54488ZM9.9303 7.80664C9.55193 7.80664 9.21167 8.05904 9.07114 8.44395L7.45601 12.868C7.41989 12.967 7.39902 13.0672 7.3918 13.1661C7.39175 13.1669 7.39112 13.1675 7.39036 13.1675V13.1675C7.38956 13.1675 7.38892 13.1681 7.38892 13.1689V13.2454V18.4211V18.4807V19.3671C7.38892 19.7537 7.70232 20.0671 8.08892 20.0671H9.19872C9.58532 20.0671 9.89872 19.7537 9.89872 19.3671V19.3671C9.89872 18.8775 10.2956 18.4807 10.7851 18.4807H18.2827C18.7349 18.4807 19.1014 18.8472 19.1014 19.2994V19.2994C19.1014 19.686 19.4148 19.9994 19.8014 19.9994H20.9112C21.2978 19.9994 21.6112 19.686 21.6112 19.2994V18.3534C21.6112 18.3497 21.6112 18.346 21.6111 18.3423V13.2463V13.2446V13.1689C21.6111 13.1681 21.6105 13.1675 21.6097 13.1675V13.1675C21.6089 13.1675 21.6083 13.1669 21.6083 13.1661C21.601 13.0672 21.5802 12.967 21.544 12.868L19.9289 8.44395C19.7884 8.05904 19.4481 7.80664 19.0698 7.80664H9.9303ZM9.06219 15.3055C9.06219 14.7532 9.5099 14.3055 10.0622 14.3055H10.572C11.1243 14.3055 11.572 14.7532 11.572 15.3055V15.6515C11.572 16.2037 11.1243 16.6515 10.572 16.6515H10.0622C9.5099 16.6515 9.06219 16.2037 9.06219 15.6515V15.3055ZM18.4281 14.3055C17.8759 14.3055 17.4281 14.7532 17.4281 15.3055V15.6515C17.4281 16.2037 17.8759 16.6515 18.4281 16.6515H18.938C19.4902 16.6515 19.938 16.2037 19.938 15.6515V15.3055C19.938 14.7532 19.4902 14.3055 18.938 14.3055H18.4281Z",
  fill: "white"
}))));

// TODO: refactor this instead of disabling
// eslint-disable-next-line react/display-name
const RetailerLogo = /*#__PURE__*/React.forwardRef(({
  s = {}
}, ref) => /*#__PURE__*/React__default["default"].createElement("span", {
  ref: ref
}, /*#__PURE__*/React__default["default"].createElement("svg", {
  viewBox: "0 0 31 50",
  style: {
    width: 31,
    height: 50,
    fill: s.color,
    ...s
  }
}, /*#__PURE__*/React__default["default"].createElement("ellipse", {
  cx: "15.4023",
  cy: "44.2344",
  rx: "4.5",
  ry: "1.5"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M15.5 0C7.21576 0 0.5 6.7507 0.5 15.0781C0.5 17.863 1.04228 20.7394 2.59844 22.8125L15.5 44.2344L28.4016 22.8125C29.815 20.9295 30.5 17.6006 30.5 15.0781C30.5 6.7507 23.7843 0 15.5 0Z"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3 8.80078C9.19548 8.80078 8.30005 9.69621 8.30005 10.8008V21.2008C8.30005 22.3054 9.19548 23.2008 10.3 23.2008H15.4999V17.0008C15.4999 16.4485 15.9476 16.0008 16.4999 16.0008H19.3599C19.9122 16.0008 20.3599 16.4485 20.3599 17.0008V23.2008H20.7C21.8046 23.2008 22.7 22.3054 22.7 21.2008V10.8008C22.7 9.69621 21.8046 8.80078 20.7 8.80078H10.3ZM10.5499 10.9508C9.99759 10.9508 9.54987 11.3985 9.54987 11.9508C9.54987 12.5031 9.99759 12.9508 10.5499 12.9508L20.4499 12.9508C21.0022 12.9508 21.4499 12.5031 21.4499 11.9508C21.4499 11.3985 21.0022 10.9508 20.4499 10.9508H10.5499ZM9.82987 17.0008C9.82987 16.4485 10.2776 16.0008 10.8299 16.0008H12.0699C12.6222 16.0008 13.0699 16.4485 13.0699 17.0008V18.2408C13.0699 18.7931 12.6222 19.2408 12.0699 19.2408H10.8299C10.2776 19.2408 9.82987 18.7931 9.82987 18.2408V17.0008Z",
  fill: "white"
}))));

// TODO: refactor this instead of disabling
// eslint-disable-next-line react/display-name
const DropOffLogo = /*#__PURE__*/React.forwardRef(({
  s = {}
}, ref) => /*#__PURE__*/React__default["default"].createElement("span", {
  ref: ref
}, /*#__PURE__*/React__default["default"].createElement("svg", {
  viewBox: "0 0 31 50",
  style: {
    width: 31,
    height: 50,
    fill: s.color,
    ...s
  }
}, /*#__PURE__*/React__default["default"].createElement("ellipse", {
  cx: "15.4023",
  cy: "43.2344",
  rx: "4.5",
  ry: "1.5"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M15.5 0C7.21576 0 0.5 6.7507 0.5 15.0781C0.5 17.863 1.04228 20.7394 2.59844 22.8125L15.5 44.2344L28.4016 22.8125C29.815 20.9295 30.5 17.6006 30.5 15.0781C30.5 6.7507 23.7843 0 15.5 0Z"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M12.8599 20.0671H12.3599V24.1004H11.3399C10.5115 24.1004 9.8399 23.4288 9.8399 22.6004V17.6004C9.8399 17.2138 9.5265 16.9004 9.1399 16.9004H8.66195C8.1943 16.9004 7.9826 16.3157 8.34186 16.0163L15.1798 10.318C15.3652 10.1635 15.6346 10.1635 15.82 10.318L22.6579 16.0163C23.0169 16.3154 22.8056 16.9004 22.3376 16.9004H21.8597C21.4722 16.9004 21.1599 17.2146 21.1599 17.6004V22.6004C21.1599 23.4288 20.4883 24.1004 19.6599 24.1004H18.6399V20.0671H18.1399C18.6399 20.0671 18.6399 20.0668 18.6399 20.0665L18.6399 20.066L18.6399 20.0646L18.6399 20.0612L18.6398 20.0514C18.6396 20.0436 18.6394 20.0333 18.639 20.0206C18.6381 19.9952 18.6366 19.9603 18.6335 19.9172C18.6274 19.8311 18.6155 19.7114 18.592 19.569C18.5454 19.2866 18.4513 18.9023 18.258 18.5119C18.0638 18.1197 17.7645 17.7115 17.3054 17.4023C16.843 17.0909 16.2484 16.9004 15.4999 16.9004C14.7514 16.9004 14.1568 17.0909 13.6944 17.4023C13.2353 17.7115 12.936 18.1197 12.7418 18.5119C12.5485 18.9023 12.4544 19.2866 12.4078 19.569C12.3843 19.7114 12.3724 19.8311 12.3663 19.9172C12.3633 19.9603 12.3617 19.9952 12.3608 20.0206C12.3606 20.0263 12.3605 20.0315 12.3604 20.0362C12.3602 20.042 12.3601 20.0471 12.36 20.0514L12.3599 20.0612L12.3599 20.0646L12.3599 20.066L12.3599 20.0665C12.3599 20.0668 12.3599 20.0671 12.8599 20.0671Z",
  stroke: "white",
  fill: "white"
}))));

exports.DriverLogo = DriverLogo;
exports.DropOffLogo = DropOffLogo;
exports.RetailerLogo = RetailerLogo;
